export const points = [
  'Automated analysis to provide deep understanding of all voice interactions',
  '90%+ accuracy in processing, analysing and interpreting calls',
  'Complete customer relationship suite, from analytics to workflow management',
  'Flagged high risk calls and explanation of failed calls',
]
